import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Building2, Lock } from "lucide-react";
import { Button } from "../components/ui/button";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AttivaStruttura() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const fonte = searchParams.get("fonte") || "";
  const [invito, setInvito] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    const urls = [
      `${API_URL}/api/commerciale/onboarding/invito/${encodeURIComponent(token)}`,
      `${API_URL}/api/farmacia/strutture/invito/${encodeURIComponent(token)}`,
    ];
    if (fonte !== "commerciale") urls.reverse();
    let cancelled = false;
    (async () => {
      for (const url of urls) {
        try {
          const res = await axios.get(url);
          if (cancelled) return;
          if (res.data?.valid) {
            setInvito({
              ...res.data,
              fonte: res.data.fonte || (url.includes("/commerciale/") ? "commerciale" : "farmacia"),
            });
            setLoading(false);
            return;
          }
        } catch {
          /* prova l'altro endpoint */
        }
      }
      if (!cancelled) {
        setInvito(null);
        setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [token, fonte]);

  if (loading) return <div className="flex min-h-screen items-center justify-center">Verifica invito…</div>;
  if (!invito) {
    return (
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="max-w-md rounded-2xl bg-white p-6 text-center shadow">
          <h1 className="text-lg font-semibold">Invito non valido o scaduto</h1>
          <p className="mt-2 text-sm text-slate-500">Contatta il mittente dell&apos;invito per riceverne uno nuovo.</p>
          <Link className="mt-4 inline-block text-sm text-emerald-700 underline" to="/login">Vai al login</Link>
        </div>
      </div>
    );
  }

  const commerciale = invito.fonte === "commerciale";
  const registerQuery = commerciale
    ? `invito_commerciale=${encodeURIComponent(token)}`
    : `invito_farmacia=${encodeURIComponent(token)}`;

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-sm">
        <Building2 className={`h-8 w-8 ${commerciale ? "text-blue-700" : "text-emerald-700"}`} />
        <h1 className="mt-3 text-xl font-semibold">Completa la registrazione di {invito.struttura_nome}</h1>
        <p className="mt-1 text-sm text-slate-500">
          {commerciale
            ? "Inserirai i dati completi, sceglierai il piano e il metodo di pagamento. Dopo l’attivazione potrai accedere ad Affidya."
            : "Inserirai i dati completi, sceglierai il piano e il metodo di pagamento. Dopo l’attivazione, tutte le strutture dell’account saranno collegate alla farmacia invitante."}
        </p>
        <Button className="mt-5 w-full" onClick={() => navigate(`/register?${registerQuery}`)}>
          <Lock className="mr-2 h-4 w-4" />Completa registrazione
        </Button>
      </div>
    </main>
  );
}
